module.exports = __webpack_public_path__ + "61905e1b6ec50bc91714bde2638071f1.pdf";